import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarnBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7850_501800)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M104 60C104 35.6995 84.3005 16 60 16C35.6995 16 16 35.6995 16 60C16 84.3005 35.6995 104 60 104C84.3005 104 104 84.3005 104 60ZM106 60C106 85.4051 85.4051 106 60 106C34.5949 106 14 85.4051 14 60C14 34.5949 34.5949 14 60 14C85.4051 14 106 34.5949 106 60Z",
				fill: "#E14949"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59 63.7499L59 37.4999C59 36.9477 59.4477 36.4999 60 36.4999C60.5523 36.4999 61 36.9477 61 37.4999L61 63.7499C61 64.3022 60.5523 64.7499 60 64.7499C59.4477 64.7499 59 64.3022 59 63.7499Z",
				fill: "#E14949"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60 78.5634C58.8954 78.5634 58 77.668 58 76.5634C58 75.4588 58.8954 74.5634 60 74.5634C61.1046 74.5634 62 75.4588 62 76.5634C62 77.668 61.1046 78.5634 60 78.5634Z",
				fill: "#E14949"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7850_501800",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	}) })]
});
export default SvgWarnBig;
